module.exports = __webpack_public_path__ + "static/cube14-126a87ce54c86d137bbbf46a37da4da5.svg";